import { render, staticRenderFns } from "./card-deal.vue?vue&type=template&id=5e2d95ce&scoped=true"
import script from "./card-deal.vue?vue&type=script&lang=js"
export * from "./card-deal.vue?vue&type=script&lang=js"
import style0 from "./card-deal.vue?vue&type=style&index=0&id=5e2d95ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d95ce",
  null
  
)

export default component.exports